import React from 'react'
import PropTypes from 'prop-types';
import { useTranslation, Trans } from 'react-i18next';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function BadWidgetModal(props) {
    const { open } = props;


    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle id="alert-dialog-slide-title">{"Did you get the right link?"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                    It appears you are trying to access an invalid widget. Please contact your facility manager.
            </DialogContentText>
            </DialogContent>
        </Dialog>
    );
}


BadWidgetModal.propTypes = {
    open: PropTypes.bool.isRequired,
};
